import axios from 'axios'

export const isTourCompleted = async (token, userName) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_GATEWAY_URL}/getTourDetails?userName=${userName}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    return response
  } catch (error) {
    throw new Error(`Failed to fetch tour details: ${error.message}`)
  }
}

export const tourCompleted = async (token, userId, tourCompleted = true) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_GATEWAY_URL}/updateTourDetails?isTourCompleted=${tourCompleted}&userId=${userId}`,
      null,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    return response.data
  } catch (error) {
    throw new Error(
      `Failed to update tour details: ${error.response.data.error}`
    )
  }
}
